import { theme } from "@academy/utils"
import type { NavSocialLinks } from "@academy/components"

// {
//   icon: "/img/social-icons/kids/youtube.jpg",
//   title: "youtube",
//   url: "https://youtube.com",
// },

const links: NavSocialLinks = {
  kids: [
    {
      icon: "/img/social-icons/kids/facebook.svg",
      iconGray: "/img/social-icons/kids/facebook-gray.svg",
      iconPrimary: "/img/social-icons/kids/facebook-primary.svg",
      title: "facebook",
      url: "https://www.facebook.com/KidEntrepreneurs.Academy",
    },
    {
      icon: "/img/social-icons/kids/instagram.svg",
      iconGray: "/img/social-icons/kids/instagram-gray.svg",
      iconPrimary: "/img/social-icons/kids/instagram-primary.svg",
      title: "instagram",
      url: "https://www.instagram.com/academy.kidpreneurs",
    },
    {
      icon: "/img/social-icons/kids/x.svg",
      iconGray: "/img/social-icons/kids/x-gray.svg",
      iconPrimary: "/img/social-icons/kids/x-primary.svg",
      title: "twitter",
      url: "https://x.com/kidpreneursa",
    },
  ],
  default: [
    {
      icon: "/img/social-icons/default/facebook.jpg",
      title: "facebook",
      url: "https://facebook.com",
    },
    {
      icon: "/img/social-icons/default/instagram.jpg",
      title: "instagram",
      url: "https://www.instagram.com/smartsafeschool__official/?igsh=NzVzcjNkZW1yMnVj",
    },
    {
      icon: "/img/social-icons/default/linkedin.jpg",
      title: "linkedin",
      url: "https://linkedin.com",
    },
    {
      icon: "/img/social-icons/default/tik_tok.jpg",
      title: "tiktok",
      url: "https://tiktok.com",
    },
    {
      icon: "/img/social-icons/default/youtube.jpg",
      title: "youtube",
      url: "https://youtube.com",
    },
  ],
}

export default links[theme] || links.default
